const DialogCloseButton = (props) => {
  const { setIsOpen } = props;

  return (
    <button
      onClick={() => setIsOpen(false)}
      className="absolute top-6 right-6 max-xs:top-4 max-xs:right-4 size-6 flex justify-center items-center"
    >
      <span className="icon icon-close-1 text-[10px] text-primary/25" />
    </button>
  );
};

export default DialogCloseButton;
